import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { Component, OnInit } from '@angular/core';

import * as moment from 'moment';

import { ScheduleProgrammingService } from '../services/schedule.service';
import { ProgrammingUtilsService } from './../../../common/services/utils.service';
import { BaseRoutingComponent } from '../../../common/base-routing/base-routing.component';

@Component({
  selector: 'prg-start-date',
  templateUrl: './start-date.component.html',
  styleUrls: ['./start-date.component.less']
})
export class StartDateComponent extends BaseRoutingComponent implements OnInit {
  startDate: Observable<any>;
  startWeekOffset: Observable<number>;
  startDayOfWeek: Observable<number>;
  startMonth: Observable<number>;
  startYear: Observable<number>;
  isFixedDate: Observable<boolean>;

  dateType: string;

  nextTenYears: Observable<Array<number>>;

  constructor(
    protected router: Router,
    protected store: Store<any>,
    private route: ActivatedRoute,
    private utils: ProgrammingUtilsService,
    protected schedule: ScheduleProgrammingService
  ) {
    super();

    this.dateType = 'fixed';

    let now = new Date();
    this.nextTenYears = Observable.range(now.getFullYear(), 10).toArray();

    this.startWeekOffset = this.store.select(s => s.scheduleProgramming.startWeekOffset);
    this.startDayOfWeek = this.store.select(s => s.scheduleProgramming.startDayOfWeek);
    this.startMonth = this.store.select(s => s.scheduleProgramming.startMonth);
    this.startYear = this.store.select(s => s.scheduleProgramming.startYear);
    this.startDate = this.store.select(s => s.scheduleProgramming.startDate);
    this.isFixedDate = this.store.select(s => s.scheduleProgramming.isFixedDate);
  }

  ngOnInit() {
  }

  setIsFixedStart(state: boolean) {
    console.log('setting fixed start: ', state);
    this.schedule.selectFixedDate(state);
  }

  setFixedStartDate(event: any) {
    console.log(event);
    this.schedule.setFixedStartDate(event.target.value);
  }

  setWeekOffset(event: any) {
    this.schedule.setWeekOffset(event.target.value);
  }

  setStartDayOfWeek(event: any) {
    this.schedule.setStartDayOfWeek(event.target.value);
  }

  setStartMonth(event: any) {
    this.schedule.setStartMonth(event.target.value);
  }

  setStartYear(event: any) {
    this.schedule.setStartYear(event.target.value);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-schedule/start-date/start-date.component.ts